import React from "react";

const BookingRightSideDetails = ({ cruiseDetails }) => {
  return (
    <div className="d-flex justify-end js-pin-content">
      <div className="w-360 lg:w-full d-flex flex-column items-center">
        <div className="px-30 py-30 rounded-4 border-light bg-white shadow-4">
          <div className="text-14 text-light-1">
            <span className="text-20 fw-500 ml-5">
              {cruiseDetails?.result_Cruise?.itineraryName}
            </span>
          </div>

          <div className="row y-gap-20 pt-30">
            <div className="col-12">
              <div className="searchMenu-date px-20 py-10 border-light rounded-4 -right js-form-dd js-calendar js-calendar-el">
                <div data-x-dd-click="searchMenu-date">
                  <h4 className="text-15 fw-500 ls-2 lh-16">Date </h4>

                  <div className="capitalize text-15 text-light-1 ls-2 lh-16">
                    <span className="js-first-date">
                      {cruiseDetails?.request?.opreationDate}
                    </span>
                  </div>
                </div>

                <div
                  className="searchMenu-date__field shadow-2"
                  data-x-dd="searchMenu-date"
                  data-x-dd-toggle="-is-active"
                >
                  <div className="bg-white px-30 py-30 rounded-4">
                    <div className="elCalendar js-calendar-el-calendar"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="searchMenu-guests px-20 py-10 border-light rounded-4 js-form-dd js-form-counters">
                <div data-x-dd-click="searchMenu-guests">
                  <h4 className="text-15 fw-500 ls-2 lh-16">Rooms Number </h4>

                  <div className="text-15 text-light-1 ls-2 lh-16">
                    {cruiseDetails?.request?.numberRooms} Room
                    {cruiseDetails?.request?.numberRooms > 1 ? "s" : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="searchMenu-guests px-20 py-10 border-light rounded-4 js-form-dd js-form-counters">
                <div data-x-dd-click="searchMenu-guests">
                  <h4 className="text-15 fw-500 ls-2 lh-16">
                    Number of travelers{" "}
                  </h4>

                  <div className="text-15 text-light-1 ls-2 lh-16">
                    {cruiseDetails?.request?.listPassengersRoomsRequests.reduce(
                      (acc, room) => acc + room.adultNumber,
                      0
                    )}{" "}
                    Adult
                    {cruiseDetails?.request?.listPassengersRoomsRequests.reduce(
                      (acc, room) => acc + room.adultNumber,
                      0
                    ) > 1
                      ? "s"
                      : null}
                    {cruiseDetails?.request?.listPassengersRoomsRequests.reduce(
                      (acc, room) => acc + room.childNumber,
                      0
                    ) > 0
                      ? ` - ${cruiseDetails?.request?.listPassengersRoomsRequests.reduce(
                          (acc, room) => acc + room.childNumber,
                          0
                        )} Child`
                      : ""}{" "}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-12">
                     <button className="button -dark-1 py-15 px-35 h-60 col-12 rounded-4 bg-blue-1 text-white">
                       ____ Now
                     </button>
                   </div> */}
          </div>

          {/* <div className="d-flex items-center pt-20">
            <div className="size-40 flex-center bg-light-2 rounded-full">
              <i className="icon-heart text-16 text-green-2"></i>
            </div>
            <div className="text-14 lh-16 ml-10">
              94% of travelers recommend ____ experience{" "}
            </div>
          </div> */}
        </div>

        {/* <div className="px-30">
          <div className="text-14 text-light-1 mt-30">
            Not sure? You can ______ this reservation up to 24 hours in advance
            for _ full refund.{" "}
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default BookingRightSideDetails;
